import { Component, OnInit, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { TaskStep } from 'src/app/data/models/task-step.model';
import { GCI140Service } from '../../../../services/gci140.service';
import { getStepDetails, getSubTaskDetails } from '../../store/selectors/sub-task-details.selectors';
import { DirtyFormGuard } from 'src/app/dirty-form.guard';
import { first } from 'rxjs/internal/operators/first';
import { updateStepStatusToInitialState } from '../../store/actions/step-status-update.actions';
import { ImagilityBaseResponse } from '../../../../data/models/response.model';
import { ReferenceLibraryService } from '../../../../services/referenceLibrary.service';
import { I140FileUploadConfiguration } from '../../../../data/models/i140UploadConfiguration';
import { SubTaskDetails } from 'src/app/data/models/subTaskDetails.model';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';
import { map } from 'rxjs/internal/operators/map';
import moment from 'moment';

@Component({
  selector: 'i140-update-decision',
  templateUrl: './update-decision.component.html',
  styleUrls: ['./update-decision.component.scss']
})
export class UpdateDecisionComponent implements OnInit {

  @ViewChild('updateDecisionForm', { static: true }) updateDecisionForm: NgForm;
  fileUploadConfigurations: I140FileUploadConfiguration;

  listResponses: [];
  receiptRefList: [];

  updateDecision: {
    beneficiaryConfirmationNumber: string;
    decissionCode: string;
    outcomeDate: Date;
    outcomeReason: string;
    rfeResponseDueDate: Date;
    isNotifyBeneficiary: boolean;
    isNotifyPetitioner: boolean;
  }

  disabledControls: boolean;
  observableSubscription$ = new Subject();
  receiptNumber: string;
  noticeMaxDate: Date;
  copyUpdateDecisionDetails: {
    beneficiaryConfirmationNumber: string;
    decissionCode: string;
    outcomeDate: Date;
    outcomeReason: string;
    rfeResponseDueDate: Date;
    isNotifyBeneficiary: boolean;
    isNotifyPetitioner: boolean;
  }
  userType: string;
  isDs160: boolean = false;

  constructor(
    private store: Store<any>,
    private dynamicDialogRef: DynamicDialogRef,
    private dynamicDialogConfig: DynamicDialogConfig,
    private gcI140Service: GCI140Service,
    private guard: DirtyFormGuard,
    private toastr: ToastrService,
    private referenceLibraryService: ReferenceLibraryService,
  ) {
    this.disabledControls = false;
    this.updateDecision = {
      decissionCode: '',
      isNotifyBeneficiary: false,
      isNotifyPetitioner: false,
      outcomeDate: new Date(),
      outcomeReason: '',
      beneficiaryConfirmationNumber: 'asdasdasd123123123',
      rfeResponseDueDate: new Date()
    }
    this.fileUploadConfigurations = {
      disableControls: this.disabledControls,
      isDocumentTypeRequired: false,
      isDocumentUploadRequired: true,
      isViewEnabled: true,
      isDownloadEnabled: true,
      isDeleteEnabled: true,
      getApiUrl: `/superTask/${this.dynamicDialogConfig.data.superTaskId}/subTask/${this.dynamicDialogConfig.data.subTaskId}/gc/i140Case/${this.dynamicDialogConfig.data.i140CaseId}/document/category/PETFORMDOC`,
      postApiUrl: `/superTask/${this.dynamicDialogConfig.data.superTaskId}/subTask/${this.dynamicDialogConfig.data.subTaskId}/gc/i140Case/${this.dynamicDialogConfig.data.i140CaseId}/document/category/PETFORMDOC/fileCategory`,
      deleteApiUrl: `/superTask/${this.dynamicDialogConfig.data.superTaskId}/subTask/${this.dynamicDialogConfig.data.subTaskId}/gc/i140Case/${this.dynamicDialogConfig.data.i140CaseId}/document/`,
      documentTypeDropdownCode: ''
    };
    this.receiptNumber = "";
    this.noticeMaxDate = new Date();
    this.userType = sessionStorage.getItem("userTypeRole");
  }

  ngOnInit(): void {
    // Get step list with details
    this.store.select(getSubTaskDetails).pipe(takeUntil(this.observableSubscription$)).subscribe((data: SubTaskDetails) => {
      this.receiptNumber = data.receiptNumber;
      this.isDs160 = data?.subTaskTypeCode === 'DS160';
    });
    this.getI140UpdateDecision();
    this.getResponseList();
    this.getReceiptType();

    this.updateDecisionForm.form.valueChanges.pipe(
      map(() => this.updateDecisionForm.dirty),
    ).pipe(takeUntil(this.observableSubscription$)).subscribe(dirty => {
      if (dirty) {
        this.store.dispatch(new MarkDirtyFormAction({
          dirty: true
        }));
      } else {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
      }
    });
  }

  getI140UpdateDecision() {
    this.gcI140Service.getI140UPdateDecisionDetails(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId).subscribe((response: ImagilityBaseResponse) => {
      this.copyUpdateDecisionDetails = {
        decissionCode: response.data['decissionCode'],
        isNotifyBeneficiary: response.data['isNotifyBeneficiary'],
        isNotifyPetitioner: response.data['isNotifyPetitioner'],
        outcomeDate: new Date(response.data['outcomeDate']),
        outcomeReason: response.data['outcomeReason'],
        beneficiaryConfirmationNumber: response.data['beneficiaryConfirmationNumber'],
        rfeResponseDueDate: new Date(response.data['rfeResponseDueDate'])
      };
      this.updateDecision = {
        decissionCode: response.data['decissionCode'],
        isNotifyBeneficiary: response.data['isNotifyBeneficiary'],
        isNotifyPetitioner: response.data['isNotifyPetitioner'],
        outcomeDate: new Date(response.data['outcomeDate']),
        outcomeReason: response.data['outcomeReason'],
        beneficiaryConfirmationNumber: response.data['beneficiaryConfirmationNumber'],
        rfeResponseDueDate: new Date(response.data['rfeResponseDueDate'])
      };
      this.fileUploadConfigurations = {
        disableControls: this.disabledControls,
        isDocumentTypeRequired: false,
        isDocumentUploadRequired: true,
        isViewEnabled: true,
        isDownloadEnabled: true,
        isDeleteEnabled: true,
        getApiUrl: `/superTask/${this.dynamicDialogConfig.data.superTaskId}/subTask/${this.dynamicDialogConfig.data.subTaskId}/gc/i140Case/${this.dynamicDialogConfig.data.i140CaseId}/document/category/RECPETDCS`,
        postApiUrl: `/superTask/${this.dynamicDialogConfig.data.superTaskId}/subTask/${this.dynamicDialogConfig.data.subTaskId}/gc/i140Case/${this.dynamicDialogConfig.data.i140CaseId}/document/category/RECPETDCS/fileCategory/`,
        deleteApiUrl: `/superTask/${this.dynamicDialogConfig.data.superTaskId}/subTask/${this.dynamicDialogConfig.data.subTaskId}/gc/i140Case/${this.dynamicDialogConfig.data.i140CaseId}/document/`,
        documentTypeDropdownCode: this.updateDecision.decissionCode
      };
      this.handleUSCISChange();
    });
  }

  getResponseList() {
    this.gcI140Service.getI140StatsReponses().pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
      this.listResponses = response.data.filter(x => x.code !== 'FILED');
    });
  }

  getReceiptType() {
    this.referenceLibraryService.getGroupReferenceData('RECPETDCS').pipe(takeUntil(this.observableSubscription$)).subscribe((response: []) => {
      this.receiptRefList = response;
    });
  }

  handleUSCISChange() {
    if (this.updateDecision.decissionCode === this.copyUpdateDecisionDetails.decissionCode) {
      this.updateDecision = Object.assign({}, this.copyUpdateDecisionDetails);
    }
    else {
      this.updateDecision = {
        decissionCode: this.updateDecision.decissionCode,
        isNotifyBeneficiary: false,
        isNotifyPetitioner: false,
        outcomeDate: null,
        outcomeReason: null,
        beneficiaryConfirmationNumber: this.updateDecision.beneficiaryConfirmationNumber,
        rfeResponseDueDate: null
      }
    }
    switch (this.updateDecision.decissionCode) {
      case "APPROVED":
        this.fileUploadConfigurations.documentTypeDropdownCode = "APPROVAL";
        break;
      case "DENIED":
        this.fileUploadConfigurations.documentTypeDropdownCode = "DENIAL";
        break;
      case "WITHDRAWN":
        this.fileUploadConfigurations.documentTypeDropdownCode = "WITHDRAW";
        break;
      case "RFEISS":
        this.fileUploadConfigurations.documentTypeDropdownCode = "RFE";
        break;
    }
  }

  postDecisionDetails() {
    const payload = {
      "beneficiaryConfirmationNumber": this.updateDecision.beneficiaryConfirmationNumber,
      "decisionName": '',
      "decissionCode": this.updateDecision.decissionCode,
      "isBeneficiaryNotify": this.updateDecision.isNotifyBeneficiary ? 1 : 0,
      "isPetitionerNotify": this.updateDecision.isNotifyPetitioner ? 1 : 0,
      "outcomeDate": this.updateDecision.outcomeDate ? moment(this.updateDecision.outcomeDate).format('YYYY-MM-DD') : null,
      "outcomeReason": this.updateDecision.outcomeReason,
      "rfeResponseDueDate": this.updateDecision.rfeResponseDueDate ? moment(this.updateDecision.rfeResponseDueDate).format('YYYY-MM-DD') : null,
    }
    this.gcI140Service.postI140UPdateDecisionDetails(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId, payload).pipe(takeUntil(this.observableSubscription$)).subscribe(
      (response: ImagilityBaseResponse) => {
        this.toastr.success(response.message, 'Success');
        this.updateDecisionForm.resetForm();
        this.getI140UpdateDecision();
      }
    );
  }

  handleClose() {
    this.guard.canDeactivate().pipe(first()).subscribe((response: boolean) => {
      if (response) {
        this.dynamicDialogRef.close();
      }
      else {
        return false;
      }
    });
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
    // Update the Step Status state to empty state
    this.store.dispatch(updateStepStatusToInitialState());
  }

}
